/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';

export default class LegacyAskRoute extends Route {}
